"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_NUMBERS = void 0;
var _analytics = require("../../helpers/analytics");
var PHONE_NUMBERS = exports.PHONE_NUMBERS = {
  YNF: [{
    title: 'United Kingdom',
    subtitle: '+44 1462 600071',
    link: {
      url: 'tel:+44 1462 600071'
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-kingdom.svg',
      alt: 'UK flag'
    }
  }, {
    title: 'United States',
    subtitle: '+1 (888) 809-0046',
    link: {
      url: 'tel:+1 (888) 809-0046'
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-states.svg',
      alt: 'American flag'
    }
  }],
  TYW: [{
    title: 'Australia',
    subtitle: '+61 (02) 8599-2224',
    link: {
      url: 'tel:+61 (02) 8599-2224',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/australia.svg',
      alt: 'Australian flag'
    }
  }, {
    title: 'Canada',
    subtitle: '+1 (613) 7770-864',
    link: {
      url: 'tel:+1 (613) 7770-864',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/canada.svg',
      alt: 'Canadian flag'
    }
  }, {
    title: 'France',
    subtitle: '+33 9 75 18 66 07',
    link: {
      url: 'tel:+33 9 75 18 66 07',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/france.svg',
      alt: 'French flag'
    }
  }, {
    title: 'Spain',
    subtitle: '+34 911 981 205',
    link: {
      url: 'tel:+34 911 981 205',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/spain.svg',
      alt: 'Spanish flag'
    }
  }, {
    title: 'United Kingdom',
    subtitle: '+44 1389 656 005',
    link: {
      url: 'tel:+44 1389 656 005',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-kingdom.svg',
      alt: 'UK flag'
    }
  }, {
    title: 'United States',
    subtitle: '+1 (949) 216-8508',
    link: {
      url: 'tel:+1 (949) 216-8508',
      className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-states.svg',
      alt: 'American flag'
    }
  }],
  TSW: [{
    title: 'United Kingdom',
    subtitle: '+44 1256 270171',
    link: {
      url: 'tel:+44 1256 270171'
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-kingdom.svg',
      alt: 'UK flag'
    }
  }, {
    title: 'United States',
    subtitle: '+1 (562) 741-5171',
    link: {
      url: 'tel:+1 (562) 741-5171'
    },
    image: {
      url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-states.svg',
      alt: 'American flag'
    }
  }],
  PB: {
    TYW: [{
      title: 'United States',
      subtitle: '+1 (888) 779 2083',
      link: {
        url: 'tel:+1 (888) 779 2083',
        className: _analytics.GA4_TRIGGERS.BOOK_CALL_CLASS
      },
      image: {
        url: 'https://cdn.theyachtweek.com/assets/phone_number_flags/united-states.svg',
        alt: 'American flag'
      }
    }]
  }
};